import Vue from "vue";
import Vuex from "vuex";
import router from "@/router";
import axios from "axios";
import { cloneDeep as _cloneDeep } from "lodash";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    authToken: null,
    userEmail: "",
    loggingIn: false,
    loginError: null,
    loginErrorMessage: ""
  },
  getters: {
    loginErrorMessage(state) {
      return _cloneDeep(state.loginErrorMessage);
    },
    logginIn(state) {
      return _cloneDeep(state.loggingIn);
    },
    authToken(state) {
      return _cloneDeep(state.authToken);
    }
  },
  mutations: {
    loginStart: state => (state.loggingIn = true),
    loginStop: (state, errorMessage) => {
      state.loggingIn = false;
      state.loginError = errorMessage;
    },
    updateAccessToken: (state, authToken) => {
      state.authToken = authToken;
    },
    updateUserEmail: (state, email) => {
      state.userEmail = email;
    },
    logout: state => {
      state.authToken = null;
      state.userEmail = "";
    },
    loginFailed: (state, message) => {
      state.loginErrorMessage = message;
    }
  },
  actions: {
    async doLogin({ commit }, loginData) {
      commit("loginStart");
      try {
        let response = await axios.post(
          "https://spend.hjertezonen.dk/wp-json/jwt-auth/v1/token",
          // "https://spend-api.lndo.site/wp-json/jwt-auth/v1/token",
          loginData
        );
        localStorage.setItem("token", response.data.token);
        localStorage.setItem("email", response.data.user_email);
        commit("updateAccessToken", response.data.token);
        commit("updateUserEmail", response.data.user_email);
        commit("loginStop", null);
        router.replace("/index.html");
      } catch (error) {
        commit("loginStop", error.response.message);
        commit("updateAccessToken", null);
      }
    },
    fetchAccessToken({ commit }) {
      commit("updateAccessToken", localStorage.getItem("token"));
    },
    logout({ commit }) {
      console.log("logging out");
      localStorage.removeItem("token");
      commit("logout");
      router.push("/login");
    }
  }
});
